import React, { useState } from "react";

export const ArticleLockButton = (props) => {
    const [locked, setLocked] = useState(props.locked);

    const onClick = () => {
        var lockValue = !locked;
        setLocked(lockValue);

        if (props.onToggle) {
            props.onToggle(locked);
        }
    };

    return (
        <div
            className={
                locked ? "btn-round fixed-left2 background-red" : "btn-round fixed-left2 background-green"
            }
            onClick={onClick}
        >
            <span className="glyphicon glyphicon-lock"></span>
        </div>
    );
};
